import React from 'react';
import { config } from '@abyss/web/tools/config';
import { styled } from '@abyss/web/tools/styled';
import { getFeature } from 'src/tools/features';
import { Brandmark } from '@abyss/web/ui/Brandmark';
import { Link } from '@abyss/web/ui/Link';

const LinkTopNavDiv = styled('div', {
  height: '108px',
});

const InsideDiv = styled('div', {
  height: '108px',
  width: '100%',
  position: 'fixed',
  background: '#fff',
  borderBottom: '1px solid #aaa',
  zIndex: '1000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 50px',
});

export const Header = () => {
  return (
    <LinkTopNavDiv>
      <InsideDiv>
        <div>
          <Brandmark
            affiliate="uhc"
            variant="lockup"
            color="blue"
            brand="uhc"
            size="lg"
          />
        </div>
        <div>
          <Link
            href={`${
              getFeature('OHID_SESSION_REWORK')
                ? `${config('IDENTITY_API_URL')}/logout/v2`
                : `${config('IDENTITY_API_URL')}/logout`
            }`}
          >
            Sign out
          </Link>
        </div>
      </InsideDiv>
    </LinkTopNavDiv>
  );
};
